<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <NextLevelPowerDropsCheckout :combos="combos" :variant="variant" />
  </b-container>
</template>
<style>
</style>

<script>
import NextLevelPowerDropsCheckout from "@/components/checkout/nextlevel/NextLevelPowerDropsCheckout.vue";

export default {
  title: "Next Level Power Drops Program",
  name: "NextLevelPowerDrops",
  props: ["combos"],
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  computed: {
    variant: function () {
      return 'A';
    },
  },
  components: {
    NextLevelPowerDropsCheckout,
  },
};
</script>
